import { AppStateService } from '@/services/app/app-state.service';
import { BinderDialogService } from '@/services/app/binder-dialog.service';
import { ClipboardService } from '@/services/app/clipboard.service';
import { UserAccessService } from '@/services/app/user-access.service';
import { DOCUMENT } from '@angular/common';
import { inject, Inject, Injectable, signal } from '@angular/core';
import { MessageService } from 'primeng/api';
import { BinderAssembly } from 'src/app/models/binder-assembly.model';

@Injectable({
  providedIn: 'root'
})
export class AssemblyImportService {
messageService = inject(MessageService);
  importedAssembly = signal<Partial<BinderAssembly>>({});
  private document: Document = inject(DOCUMENT); 
  private clipboardService: ClipboardService = inject(ClipboardService);
  private binderDialogService: BinderDialogService = inject(BinderDialogService);
  private appStateService: AppStateService = inject(AppStateService);
  private userAccessService: UserAccessService = inject(UserAccessService);
  

  // constructor(
  // ) { 
  //   this.document = inject(DOCUMENT); 
  // }

  ngOnInit() {
    this.document.addEventListener('paste', this.onPasteEvent.bind(this));
}

  private async pasteAssembly() {
    let assembly: Partial<BinderAssembly> = {};
    const pastedData = await this.clipboardService.pasteData();
    if(!pastedData?.BAID && !pastedData?.AID) {
      return null;
    }
    if(this.userAccessService.foundersRestrictedAccess()) {
      if(!this.userAccessService.foundersCategories().includes(pastedData.CategoryID)) {
        this.messageService.add({severity: 'error', summary: 'Error', detail: 'Incompatible assembly category'});
        return null;
      }
    }
    if (pastedData) {
      assembly = 
      {
      Name: pastedData?.Name,
      Type: pastedData?.Type,
      Description: pastedData?.Description,
      Price: pastedData?.Price,
      AID: pastedData?.AID,
      Quantity: pastedData?.Quantity,
      CategoryID: pastedData?.CategoryID,
      Categories: pastedData?.Categories,
      TaxFree: pastedData?.TaxFree
    }
  }
  return assembly;
  }

  onPasteEvent(event: ClipboardEvent) {
    if(this.appStateService.isBinderEditor || this.appStateService.isAssemblyEditor) {
      this.importAssemblyFromClipboard();
    }
  }

  async importAssemblyFromClipboard() {
    const assembly = await this.pasteAssembly();
    if (assembly && !this.binderDialogService.isDialogOpen()) {
      this.importedAssembly.set(assembly);
      this.binderDialogService.toggleDialog('Import Assembly', 'assembly-import', true);
    }
  }
}
